import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { ToastContainer } from 'react-toastify'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import { TABLE_CAMIONES_CALADOS } from '../../../config/tables'
import { updateTablaCamionesCaladosRepresentantes } from '../actions'
import { FORM_LISTADO_REPRESENTANTES } from '../../../config/forms'
import { INTERVALO_CORTO } from '../../../config/settings'
import FormListadoRepresentantes from '../components/FormListadoRepresentantes'

function ListadoRepresentantes (props) {
  const [show, setShow] = useState(false)
  const { updateTablaCamionesCaladosRepresentantes } = props

  useEffect(() => {
    const interval = setInterval(() => {
      if (show) {
        updateTablaCamionesCaladosRepresentantes()
      }
    }, 380000)

    return () => {
      clearInterval(interval)
    }
  }, [show, updateTablaCamionesCaladosRepresentantes])

  const actualizarListado = () => {
    setShow(true)
    updateTablaCamionesCaladosRepresentantes()
  }

  return (
    <div className='stock-container'>
      <FormListadoRepresentantes actualizarListado={actualizarListado} />
      <hr />
      {show
        ? <MuiTable id={TABLE_CAMIONES_CALADOS} />
        : <p
          style={{ textAlign: 'left', margin: '0 12px', float: 'left' }}
          className='box-info'
        >
            Seleccione una fecha para visualizar el listado de códigos de cupos
        </p>
      }
      <ToastContainer autoClose={INTERVALO_CORTO} />
    </div>
  )
}

const mapActionsToProps = {
  updateTablaCamionesCaladosRepresentantes
}

const withRedux = connect(null, mapActionsToProps)
const withReduxForm = reduxForm({
  form: FORM_LISTADO_REPRESENTANTES
})

export default withRedux(withReduxForm(ListadoRepresentantes))
